import { gql } from '@apollo/client'

export const GET_ONE_BY_ONE_SURVEY_BY_ID = gql`
  query GetOneByOneSurveyAnswerUser(
    $surveyId: Int
    $limit: Int
    $offset: Int
    $userId: Int
    $searchByIndex: Int
  ) {
    getOneByOneSurveyAnswerUser(
      surveyId: $surveyId
      limit: $limit
      offset: $offset
      userId: $userId
      searchByIndex: $searchByIndex
    ) {
      count
      prevUserId
      nextUserId
      rows {
        id
        answer_text
        question_id
        question_option_id
        surveysAnswerUserToSurveys {
          id
          title
          description
          surveysToSurveysQuestions {
            id
            order
            is_required
            question_text
            type_question_id
            survey_id
            surveysQuestionsToSurveyQuestionOptions {
              id
              option_text
              order
              question_id
              value
            }
            surveysQuestionsTosurveyQuestionType {
              description
              id
              key
              name
            }
          }
        }
      }
    }
  }
`
